import { IDateRange } from '../../../types/dateRange';
import { formatDate } from './formatDate';

export function getDateRangeText(dateRange: IDateRange): string {
  const { from, to } = dateRange;

  const formattedFrom = from ? formatDate(from) : 'Заезд';
  const formattedTo = to ? formatDate(to) : 'Отъезд';

  return `${formattedFrom} — ${formattedTo}`;
}
